__turbopack_context__.v({
  "rich-text": "EditorText-module-scss-module__SMt3zG__rich-text",
  "size-lg": "EditorText-module-scss-module__SMt3zG__size-lg",
  "size-md": "EditorText-module-scss-module__SMt3zG__size-md",
  "size-sm": "EditorText-module-scss-module__SMt3zG__size-sm",
});
